import React from "react";
import Logo from "../../../utils/logo";
import ThemeToggler from "../../../components/Theme/Themetoggler";

const Header = () => {
  return (
    <div className={`w-full h-24`}>
      <div className="pl-2 pr-2 flex items-center justify-between  h-20">
        <Logo />
        <ThemeToggler />
      </div>
    </div>
  );
};

export default Header;
